import React from "react";
import { Avatar } from "@mui/material";
import { convertLetterToNumber, getInitialsOfName } from "../../utils";
import { getBackgroundColor } from "./helpers";

import AnimatedPlaceholder from "./styles";

const UserPicture = ({
  size = 70,
  image,
  name = "X",
  surname = "X",
  loading,
  color,
  className,
}) => {
  if (loading) {
    return (
      <Avatar sx={{ width: size, height: size }} className={className}>
        <AnimatedPlaceholder />
      </Avatar>
    );
  }

  const initials = getInitialsOfName(name, surname);
  const finalBgColor =
    color || getBackgroundColor(convertLetterToNumber(initials[0]));

  if (!image) {
    return (
      <Avatar
        sx={{ width: size, height: size, bgcolor: finalBgColor }}
      >{`${initials[0]}${initials[1]}`}</Avatar>
    );
  }

  return <Avatar src={image} sx={{ width: size, height: size }} />;
};

export default UserPicture;
